
import Component from "vue-class-component";
import Vue from "vue";
import {
    SpecialityLightModel,
    SysAdminSpecialitiesClient, SystemOperationsClient
} from "@/api-client";
import { BvTableFieldArray } from "bootstrap-vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import { translateTrueFalse } from "@/features/shared/TrueFalseTranslator";
import Loader from "@/features/shared/components/Loader";
import {debounceFn} from "debounce-decorator-ts";
import toasts from "@/components/Toasts";
import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";

@Component({
  components: {
    SectionPageHeading,
      ConfirmModal
  },
})
export default class SystemOperations extends Vue {
  operationKey = "";
  loader = new Loader();
  
  $refs!:{
      confirmModal: ConfirmModal;
  }
  
  execute(){
      new SystemOperationsClient().setLoader(this.loader).execute(this.operationKey).then(() => {
          toasts.success("Toiming käivitatud!");
      }).catch(error => {
          toasts.failure("Toiming ei õnnestunud!");
          console.log(JSON.stringify(error));
          throw error;
      });
  }

}
